module.exports = __webpack_public_path__ + "static/media/auditoriumMobile.5fab8506.jpg";